/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import Linedataset from '@fusioncharts/charts/src/dataset/line';
import { pluckNumber, pluck, getFirstValue, toRaphaelColor, preDefStr }
  from '@fusioncharts/core/src/lib';
import { addDep } from '@fusioncharts/core/src/dependency-manager';
import boxandwhiskerlineAnimation from './boxandwhiskerline.animation';
let UNDEF,
  POLYGON = preDefStr.POLYGON,
  SPOKE = preDefStr.SPOKE,
  BOLDSTARTTAG = '<b>',
  BOLDENDTAG = '</b>',
  /**
   * Helper function to create a RedRaphael group.
   * @param  {Object} attrs  List of attributes that are applied to the created group.
   * @param  {Element} parentContainer         The parent container in which the group will be appended.
   * @param {Object} dataset The concerned dataset
   * @return {Element}                         The group that was created.
   */
  createGroup = function (attrs, parentContainer, dataset) {
    return dataset.getFromEnv('animationManager').setAnimation({
      el: 'group',
      attr: attrs,
      container: parentContainer,
      component: dataset,
      label: 'group'
    });
  };
addDep({
  name: 'boxandwhiskerlineAnimation',
  type: 'animationRule',
  extension: boxandwhiskerlineAnimation
});
/**
 * Class for boxAndWhiskerLine dataset
 */
class BoxAndWhiskerLinedataset extends Linedataset {
  /**
   * Gets the name of the component
   * @return {string} name
   */
  getName () {
    return 'boxandwhiskerline';
  }
  /**
   * Create pixel coordinates for the plots
   */
  createCoordinates () {
    var dataset = this,
      dsData = dataset.components.data,
      // chart = dataset.getFromEnv('chart'),
      // isBar = chart.isBar,
      yAxis = dataset.getFromEnv('yAxis'), // eslint-disable-line good-practices/no-single-usage-variable
      xAxis = dataset.getFromEnv('xAxis'), // eslint-disable-line good-practices/no-single-usage-variable
      // yBase = yAxis.getAxisBase(),
      // yBasePos = yAxis.getPixel(yBase),
      dataObj,
      config,
      // previousY,
      i,
      Px,
      Py,
      len = dsData.length; // eslint-disable-line good-practices/no-single-usage-variable

    // !isBar && (xDepth = -xDepth);
    // isBar && (yDepth = -yDepth);

    for (i = 0; i < len; i++) {
      dataObj = dsData[i];
      config = dataObj && dataObj.config;

      if (dataObj === UNDEF) {
        continue;
      }
      // previousY = config._b;
      Px = xAxis.getPixel(config._x);
      Py = yAxis.getPixel(config._y);
      // Pb = (previousY ? yAxis.getPixel(previousY) : yBasePos) + yDepth;

      config._Px = Px + dataset.getFromEnv('columnXShift') + dataset.getFromEnv('columnWidth') / 2;
      config._Py = Py;
      // config._Pby = Pb;
      // config._Pbx = Px;
    }
  }
  /**
  * Returns all plots between the provided category indices
  * @param {Number} min Min category index
  * @param {Number} max Max category index
  * @return {Array} Plots between those indices
  */
  getAllPlots (min, max) {
    let data = this.components.data,
      allPlots = [],
      i,
      len;
    for (i = 0, len = data.length; i < len; i++) { // eslint-disable-line good-practices/no-single-usage-variable
      if (data[i].config._x >= min || data[i].config._x <= max) {
        allPlots.push(data[i]);
      }
    }
    return allPlots;
  }

  /**
   * calculate min and max position to scroll
   */
  calculateScrollRange () {
    let dataSet = this,
      conf = dataSet.config,
      data = dataSet.components.data; // eslint-disable-line good-practices/no-single-usage-variable
    conf.scrollMinVal = 0;
    conf.scrollMaxVal = data.length;

    // Since panning and data skipping are not applicable for scatter and bubble charts, the labels'
    // minimum and maximum index to be drawn is the same as the plots' minimum and maximum index.
    conf.scrollMinValForLabel = conf.scrollMinVal;
    conf.scrollMaxValForLabel = conf.scrollMaxVal;
  }
  /**
   * Function that return the nearest plot details
   * @param   {number} chartXVal x-axis position of the mouse cordinate
   * @param   {number} chartYVal y-axis position of the mouse cordinate
   * @return {Object} return an object with details of nearest plot and whether it is
   *                   hovered or not
   */
  _getHoveredPlot (chartXVal, chartYVal) {
    var dataset = this,
      chartX = chartXVal,
      chartY = chartYVal,
      xAxis = dataset.getFromEnv('xAxis'),
      dataStore = dataset.components.data, // eslint-disable-line good-practices/no-single-usage-variable
      pointObj,
      xMin,
      xMax,
      len = dataStore.length, // eslint-disable-line good-practices/no-single-usage-variable
      returnValue,
      conf = dataset.config,
      j,
      maxRadius = (conf && conf.radius) || 0,
      allPlots;

    // getting new chart XY accordint to Translation of axis
    chartX += xAxis.getTranslation();

    xMin = Math.floor(Math.max(xAxis.getValue(chartX - maxRadius), 0)); // eslint-disable-line good-practices/no-single-usage-variable

    xMax = Math.ceil(Math.min(xAxis.getValue(chartX + maxRadius), len - 1)); // eslint-disable-line good-practices/no-single-usage-variable
    allPlots = dataset.getAllPlots(xMin, xMax);
    for (j = allPlots.length; j >= 0; j--) {
      pointObj = allPlots[j];
      if (pointObj) {
        returnValue = dataset.isWithinShape(pointObj, j, chartX, chartY);
        if (returnValue) {
          break;
        }
      }
    }

    return returnValue;
  }
  /**
   * Function to add legend for LineDs only when the function is called from its parent ds
   * @param {boolean} callFromParentDS if call is from parent ds
   */
  _addLegend (callFromParentDS) {
    if (!callFromParentDS) {
      return;
    }
    var dataset = this,
      conf = dataset.config,
      legend = dataset.getFromEnv('chart').getChildren('legend')[0],
      legendItem,
      drawAnchors = pluckNumber(conf.drawanchors, 1), // eslint-disable-line good-practices/no-single-usage-variable
      config;
    if (conf.includeinlegend) {
      config = {
        anchorSide: drawAnchors ? conf.anchorsides : 0,
        label: getFirstValue(conf.JSONData.seriesname),
        customLegendIcon: false,
        spoke: (conf.dip === 'spoke') ? 1 : 0,
        drawLine: !conf.showline,
        index: dataset.getJSONIndex()
      };
      legendItem = legend.getItem(dataset.config.legendItemId);
      if (!legendItem) {
        dataset.config.legendItemId = legend.createItem(dataset);
        legendItem = legend.getItem(dataset.config.legendItemId);
        dataset.addExtEventListener('fc-click', function () {
          legendItem.itemClickFn();
        }, legendItem);
      }
      legendItem.configure(config);
      legendItem.setStateCosmetics('default', {
        symbol: {
          fill: toRaphaelColor({
            color: conf.anchorbgcolor,
            alpha: conf.anchorbgalpha
          }),
          rawFillColor: conf.anchorbgcolor,
          stroke: toRaphaelColor({
            color: conf.anchorbordercolor,
            alpha: '100'
          })
        },
        background: {
          legendBackgroundColor: toRaphaelColor(dataset.getFromEnv('legendBackgroundColor')),
          alpha: 20
        }
      });
      // check if dataset is initiallyhidden
      if (!dataset.getState('visible')) {
        legendItem.setLegendState('hidden');
      } else { // remove hidden state of legend item is dataset is not hidden
        legendItem.removeLegendState('hidden');
      }
    } else if (dataset.config.legendItemId) {
      legend.disposeItem(dataset.config.legendItemId);
    }
  }

  /**
    * Function for parsing all the attributes and value given by the user at chart,dataset and set level.
    * @param  {Object} datasetJSON JSON for dataset configurations
    */
  configureAttributes (datasetJSON) {
    super.configureAttributes(datasetJSON);
    var dataset = this,
      JSONData = dataset.config.JSONData,
      conf = dataset.config;
    dataset.setState('visible', dataset.getLinkedParent().getState('visible'));
    // chartAttr = dataset.getFromEnv('chart-attrib');

    conf.skipCommonElements = JSONData.showline;
    conf.dip = JSONData.dip;
  }

  /**
   * function to create group for dataset
   */
  createContainer () {
    var dataset = this,
      parent = dataset.getLinkedParent().getLinkedParent(),
      group = (dataset.groupName || dataset.dsGroup || dataset.getType()),
      parentContainer,
      parentShadowContainer;

    !parent.getChildContainer(group + 'VcanvasGroup') && (group = 'default');
    parentContainer = parent.getChildContainer('manager-defaultVcanvasGroup-lines');
    parentShadowContainer = parent.getChildContainer(group + 'ShadowVcanvasGroup'); // eslint-disable-line good-practices/no-single-usage-variable

    !dataset.getContainer('shadowGroup') && dataset.addContainer('shadowGroup',
      createGroup({ name: 'shadow-group' }, parentShadowContainer, dataset));

    !dataset.getContainer('commonElemsGroup') && dataset.addContainer('commonElemsGroup',
      createGroup({ name: 'common-elems-group' }, parentContainer, dataset));

    !dataset.getContainer('plotGroup') && dataset.addContainer('plotGroup',
      createGroup({ name: 'common-elems-group' }, parentContainer, dataset));

    !dataset.getContainer('labelGroup') && dataset.addContainer('labelGroup',
      createGroup({ name: 'label-group',
        class: 'fusioncharts-datalabels',
        opacity: 1 }, parent.getChildContainer('vcanvasLabelGroup'), dataset));
  }

  /**
   * Configure data level
   * @param {Object} newDataset new dataset added
   * @param {Object} newIndex new added dataset index
   */
  _setConfigure (newDataset, newIndex) {
    var dataSet = this,
      conf = dataSet.config,
      chartConfig = dataSet.getFromEnv('chartConfig'), // eslint-disable-line good-practices/no-single-usage-variable
      JSONData = dataSet.config.JSONData,
      setDataArr = newDataset || JSONData.data || [],
      setData,
      dataObj,
      catLen = dataSet.getFromEnv('xAxis').getTicksLen(), // eslint-disable-line good-practices/no-single-usage-variable
      newDataSetLen = newDataset && newDataset.data.length,
      len = (JSONData.seriesname === 'Outliers' ? setDataArr.length
        : (newDataSetLen || Math.min(catLen, setDataArr.length))),
      dataStore,
      i,
      plotIndex,
      config,
      outlierIconShape,
      tempIndex;

    conf.imageCount = 0;
    dataStore = dataSet.components.data;
    if (!dataStore) {
      dataStore = dataSet.components.data = [];
    }
    conf.maxRadius = -Infinity;

    for (i = 0; i < len; i++) {
      if (newDataset) {
        setData = (newDataset && newDataset.data[i]) || {};

        if (newIndex !== UNDEF) {
          tempIndex = newIndex + i;
          dataObj = dataStore[tempIndex];
        } else {
          tempIndex = dataStore.length - len + i;
          dataObj = dataStore[tempIndex];
        }
        plotIndex = tempIndex;
      } else {
        dataObj = dataStore[i];
        setData = (setDataArr && setDataArr[i]) || {};
        plotIndex = i;
      }

      if (!dataObj) {
        dataObj = dataStore[plotIndex] = {};
      }

      if (!dataObj.config) {
        dataObj.config = {};
      }

      if (!dataObj.graphics) {
        dataObj.graphics = {};
      }

      dataSet._plotConfigure(plotIndex, setData, newDataSetLen);
      tempIndex && tempIndex++;

      config = dataObj && dataObj.config;
      outlierIconShape = pluck(setData.dip, JSONData.dip);
      config.dip = (outlierIconShape === POLYGON) ? 0 : (outlierIconShape === SPOKE) ? 1 : 0;
      config.toolText = config.finalTooltext = BOLDSTARTTAG + JSONData.seriesname + chartConfig.tooltipsepchar + BOLDENDTAG + config.displayValue;
    }
  }
}

export default BoxAndWhiskerLinedataset;
